import React from "react";
import styles from "./TermsAndConditions.module.css";

const PrivacyPolicy = () => {
  return (
    <div className={styles.termsContainer}>
      <h1 className={styles.title}>Sageion.com Privacy Policy</h1>
      <p className={styles.subtitle}>
        Last Revised: October 13, 2025. Please read carefully.
      </p>

      {/* 1. Data Ownership */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>1. Data Ownership</h2>
        <p className={styles.text}>
          You retain all rights to the data you provide to Sageion.com (“Your Data”).
        </p>
      </section>

      {/* 2. Usage of Data */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>2. Usage of Data</h2>
        <p className={styles.text}>
          Sageion.com uses Your Data solely to provide the Services and improve the platform.
        </p>
      </section>

      {/* 3. Responsibilities */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>3. Responsibilities</h2>
        <p className={styles.text}>
          You warrant that all uploaded data is lawful, does not infringe third-party rights, and does not contain harmful content.
        </p>
      </section>

      {/* 4. Data Retention */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>4. Data Retention</h2>
        <p className={styles.text}>
          Your Data is retained for the duration of your active account and for six (6) months thereafter, unless retention is required by law.
        </p>
      </section>

      {/* 5. Security Measures */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>5. Security Measures</h2>
        <p className={styles.text}>
          We implement reasonable measures to protect your data from unauthorized access, disclosure, or destruction.
        </p>
      </section>

      {/* 6. Third-Party Services */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>6. Third-Party Services</h2>
        <p className={styles.text}>
          Your use of Sageion.com may involve interaction with third-party services. We are not responsible for acts, omissions, or failures of third-party providers.
        </p>
      </section>

      <footer className={styles.footer}>
        <p className={styles.footerText}>
          Last updated: October 13, 2025. For inquiries, contact us at <a href="mailto:support@sageion.com">support@sageion.com</a>.
        </p>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
